import type { SiteSettings } from './types';

/**
 * Canonical site settings — SEO/GEO/contact single source of truth.
 *
 * This constant is the hardcoded source (the `useSiteSettings` hook returns it directly).
 * Edit here to change site-wide email / address / area-served / default meta.
 */
export const SITE_SETTINGS_FALLBACK: SiteSettings = {
  id: 'singleton',
  siteName: 'BRANDCENTRAL',
  tagline: 'AI Agency · Operations · Web · Apps',
  // Kept 140-180 chars so it survives Google's desktop snippet limit
  // (~160) without truncation. Drives both the dynamic <Seo> meta on
  // HomePage and the live LocalBusiness JSON-LD `description` field.
  // Leads with the AI Agency positioning and surfaces Charlotte +
  // Lake Norman by name for local rank signals.
  defaultMetaDescription:
    'BRANDCENTRAL is an AI Agency in Mooresville, NC: custom AI agents, automation, web design, and operations consulting for Charlotte and Lake Norman teams.',
  ogImageUrl: 'https://brandctl.com/og-image.png',
  businessCity: 'Mooresville',
  businessRegion: 'NC',
  businessCountry: 'US',
  businessPostalCode: '28117',
  latitude: 35.5848,
  longitude: -80.8101,
  email: 'hello@brandctl.com',
  areaServed: [
    'Mooresville, NC',
    'Lake Norman, NC',
    'Charlotte, NC',
    'Cornelius, NC',
    'Davidson, NC',
    'Huntersville, NC',
    'Concord, NC',
    'Statesville, NC',
    'United States',
  ],
};
